import { render } from "./PaymentBlock.vue?vue&type=template&id=6ba18360&scoped=true"
import script from "./PaymentBlock.vue?vue&type=script&lang=js"
export * from "./PaymentBlock.vue?vue&type=script&lang=js"

import "./PaymentBlock.vue?vue&type=style&index=0&id=6ba18360&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ba18360"
/* hot reload */
if (module.hot) {
  script.__hmrId = "6ba18360"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ba18360', script)) {
    api.reload('6ba18360', script)
  }
  
  module.hot.accept("./PaymentBlock.vue?vue&type=template&id=6ba18360&scoped=true", () => {
    api.rerender('6ba18360', render)
  })

}

script.__file = "src/components/blocks/PaymentBlock.vue"

export default script